import React from 'react';
import { useIntl } from 'react-intl';

import type { CertificateItemTagProps } from './types';
import { getIconForType, itemTypeMessageId } from './utils';

import styles from './styles.module.scss';

export const CertificateItemTag = (props: CertificateItemTagProps): React.ReactElement => {
  const intl = useIntl();
  const { item } = props;
  const icon = getIconForType(item.type);
  const label = intl.formatMessage(
    { id: 'certificates.card.tag.nights' },
    {
      type: intl.formatMessage({ id: itemTypeMessageId(item.type) }),
      nights: item.nights,
    },
  );

  return (
    <span className={styles.tag}>
      <img src={icon} alt="" aria-hidden />
      <span>{label}</span>
    </span>
  );
};
